import moment from "moment";
import "moment/locale/pt-br";
import BaseService from '../base.service'
import store from '@/store'
import { Feature_Flags } from "@/enums/globals";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

export default class OrderService extends BaseService{

    constructor(){
        super();
    }


    all(cursor = null, size = 10 ,filters: any = {}) {
        let filter = ''
        let now = moment.utc()

        if (filters.today) {
            if (!filters.from) {
                filter += `&filter[from]=${now.format("YYYY-MM-DD")}`
                delete filters.from
            }

            if (!filters.to) {
                filter += `&filter[to]=${now.format("YYYY-MM-DD")}`
                delete filters.to
            }
        }
        filter += '&'
        filter += Object.keys(filters)
                .filter(k => { return k != 'today' })
                .map(k => { return `filter[${encodeURIComponent(k)}]` + '=' + encodeURIComponent(filters[k])})
                .join('&')
        let url = this.baseURL + `orders?size=${size}${filter}&include=items&with_cursor=1&cursor=${cursor}`;
        return super.get(url);
    }

    orderstatuses() {
        this.conceptId = store.getters['account/activeConcept'].id
        let url = this.baseURL + 'concepts/' + this.conceptId + '/statuses';
        return super.get(url);
    }

    activeStatusList() {
        const concept = store.getters['account/activeConcept'].key;
        let url = this.baseURL + 'concepts/' + concept + '/statuses';
        return super.get(url);
    }

    orderStatuses() {
        let url = this.baseURL + 'orders/statuses';
        return super.get(url);
    }


    updateorderstatuses(payload: Object = {}, orderstatusID: string | number) {
        this.conceptId = store.getters['account/activeConcept'].id
        let url = this.baseURL + `concepts/` + this.conceptId + `/statuses/${orderstatusID}`

        return super.patch(url, payload);
    }

    validate(params: object = {}) {
        let url = this.baseURL + 'orders/validate'

        return super.post(url, params);
    }

    store(params: {}) {

        let url = this.baseURL + 'orders';

        return super.post(url, params);
    }

    coupon(coupon: string){
        let url = this.baseURL + 'coupons?coupon-code=' + coupon + '&include=promotion' ;
        return super.get(url);
    }

    applycoupon(params: {}){
        let url = this.baseURL + 'orders?include=promotion';

        return super.post(url, params);
    }

    hyperpay(params: {})
    {
        let url = this.baseURL + 'hyperpay/checkout';

        return super.post(url, params);
    }

    hyperpayStatus(params: {})
    {
        let url = this.baseURL + 'hyperpay/get-payment-status';

        return super.post(url, params);
    }

    getOrderStatusSync(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/sync';

        return super.get(url)
    }

    find(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '?include=items';

        return super.get(url)
    }

    statuses(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/statuses?filter[visible]=1';

        return super.get(url)
    }

    updatePromisedTime(orderId: string, payload: any) {
        const url = this.baseURL + 'orders/' + orderId;

        return super.patch(url, payload);
    }

    feedback(params: {})
    {
        let url = this.baseURL + 'feedback'
        let headers = {
            "Content-Type": "form-data"
        }
        return super.post(url, params, headers)
    }

    postedFeedback(orderId: string)
    {
        let url = this.baseURL + 'orders/'+ orderId +'/ratings/topics'

        return super.get(url)
    }

    topics()
    {
        let url = this.baseURL + '/topics'

        return super.get(url)
    }

    findItems(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/items';

        return super.get(url)
    }

    findResource(orderId: string,itemOrderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/items/' + itemOrderId + '?include=items';

        return super.get(url)
    }

    statusList() {
        let url = this.baseURL + `orders/statuses`
        return super.get(url)
    }

    findStatuses(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/statuses';

        return super.get(url)
    }

    findDriver(orderId: string){
        let url = this.baseURL + 'orders/' + orderId + '/employees?filter[function]=driver';

        return super.get(url)
    }

    updateStatus(payload: Object = {}, orderId: string) {

        let url = this.baseURL + `orders/${orderId}/statuses`

        return super.post(url, payload)
    }

    updatePaymentMethod(payload: Object = {}, orderId: string | number) {

        let url = this.baseURL + `orders/${orderId}/payments`

        return super.post(url, payload)
    }



    updateDate(payload: Object = {}, orderID: string | number) {

        let url = this.baseURL + `orders/${orderID}`

        return super.patch(url, payload);
    }


    cancel(orderId: string, params: any) {

        let url = this.baseURL + 'orders/' + orderId + '/cancellation';

        return super.patch(url, params);
    }

    exportOrder(orderId: string) {
        let url = this.baseURL + `orders/${orderId}/exports`

        return super.post(url, {});
    }

    exportAllOrder(filters: {[key: string]: any} = {}) {
      let filter = "";
      const { isFeatureEnabled } = useFeatureFlags();
      const v2_ExportOrders = isFeatureEnabled(Feature_Flags.PORTAL_ORDERS_EXPORTING);
      const filterVariant = v2_ExportOrders ? "filters" : "filter";
      
      if (v2_ExportOrders) {
        // TODO: this is hotfix it should be removed when getOrder api will support the below revamped properties than we can change the properties in filters interface and remove from here.
        const filterMappings = {
          "payment-type": "payment_types",
          "device-id": "device_ids",
          status: "statuses",
          order: "order_id",
          customer: "customer_name",
          email: "customer_email",
          mobile: "customer_mobile",
          location: "locations",
          type: "types",
          source: "sources",
        };
        Object.entries(filterMappings).forEach(([oldKey, newKey]) => {
            if (!filters[oldKey]) return;
            filters[newKey] = filters[oldKey];
            delete filters[oldKey];
        });
      }

      if (v2_ExportOrders) {
        const processedKeys: string[] = [];

        Object.keys(filters).forEach((key) => {
          if (key !== "today" && Array.isArray(filters[key])) {
            // this is a patch for source names
            if (key === 'sources') {
                const mapUpdatedSourcesName: Record<string, string> = {
                    "Call Center": "call-center",
                    "Kiosk": "kiosk",
                    "iOs": 'iOS',
                }
                filters[key] = filters[key].map((value: string) => {
                    return mapUpdatedSourcesName[value] || value;
                });
            }
            filters[key].forEach((value: string, index: number) => {
                if(!value) return
                filter += `&${filterVariant}[${encodeURIComponent(
                    key
                )}][${index}]=${encodeURIComponent(value)}`;
            });
            processedKeys.push(key);
          }
        });

        // Remove processed array filters
        processedKeys.forEach((key) => delete filters[key]);
      }

      filter += "&";
      filter += Object.keys(filters)
        .filter((k) => {
          return k != "today";
        })
        .map((k) => {
          return (
            `${filterVariant}[${encodeURIComponent(k)}]` +
            "=" +
            encodeURIComponent(filters[k] ?? "")
          );
        })
        .join("&");

      console.log("filter: ", filter);

      console.log("filters sa sa: ", filters);

      // Build URL and headers
      const baseEndpoint = v2_ExportOrders
        ? "api/exports/orders"
        : "orders/exports";
      const url = `${this.baseURL}${baseEndpoint}?${filter}`;
      const headers: { [key: string]: string } = v2_ExportOrders
        ? { Accept: "application/vnd.solo.v2+json" }
        : {};

      return super.post(url, {}, headers);
    }

    exportERP(date: string = '') {
        let url = this.baseURL + `reports/daily-sales/export?date=${date}`

        return super.get(url, {});
    }

    orderPayment(orderId: string) {
        let url = this.baseURL + `orders/${orderId}/payments`

        return super.get(url)
    }

    orderDetails(orderId: string) {
        let url = this.baseURL + `orders/${orderId}?include=items,modifiers,customerAddress,payfortHooks`

        return super.get(url)
    }

    getCustomer(orderId: string) {
        let url = this.baseURL + `customers/${orderId}`

        return super.get(url)
    }

    getCustomerAddresses(customerId: string) {
        let url = this.baseURL + `customers/${customerId}/addresses`

        return super.get(url)
    }

    getDeliveryLogs(orderID: any) {
      let log = this.baseURL1 + `delivery-logs?filter[order-id]=${orderID}`;

      return super.get(log);
    }

    getPaymentLogs(orderID: any) {
      let log = this.baseURL1 + `payments?filter[order-id]=${orderID}`;

      return super.get(log);
    }
}
